import isUndefined from 'lodash/fp/isUndefined';
import { DEFAULT_VEHICLE_PROFILE } from '../../common/constants';
import type { RootDispatch, RootState } from '../../configuration/setup/store';
import { trace } from '../../configuration/setup/trace';
import { facadeApiV3 } from '../../store/facade/facadeApiV3';
import { selectProfileTypeField } from '../../store/vehicleProfile/vehicleProfileSelectors';
import { changeProfileDetails, changeVehicleType } from '../../store/vehicleProfile/vehicleProfileSlice';

export const loadProfiles = async (dispatch: RootDispatch, getState: () => RootState) => {
    try {
        const { data: profiles, error: profilesError } = await dispatch(
            facadeApiV3.endpoints.getVehicleProfileList.initiate()
        );

        if (profilesError || isUndefined(profiles)) {
            throw new Error('Could not fetch profiles');
        }

        const defaultProfile = profiles.find(profile => profile.profileName === DEFAULT_VEHICLE_PROFILE);
        if (isUndefined(defaultProfile)) {
            trace.warn('Default vehicle profile not found in profile list');
            throw new Error('Could not find default profile');
        }

        const { data: profileDetails, error: profileDetailsError } = await dispatch(
            facadeApiV3.endpoints.getVehicleProfileDetails.initiate({ id: defaultProfile.id })
        );

        if (profileDetailsError || isUndefined(profileDetails)) {
            throw new Error('Could not fetch default profile details');
        }

        if (!profileDetails.id || !profileDetails.profileName) {
            trace.warn('Incomplete profile information received:', profileDetails.id);
        }

        const profileTypeField = selectProfileTypeField(getState());
        if (!profileTypeField.isEditable) {
            return;
        }

        dispatch(changeVehicleType(profileDetails.id));
        dispatch(changeProfileDetails(profileDetails));
    } catch (error) {
        trace.error('Could not fetch profiles', error);
    }
};
